<div class="container-fluid">
    <div class="row">

        <div class="col-sm-3">
            <sanabel-selectize appcode="1023" [disabled]="true" [(ngModel)]="patientCode">
            </sanabel-selectize>

        </div>

        <div class="col-sm-3" >
                <sanabel-selectize appcode="24" [tabindex]="35" [(ngModel)]="patientBloodTypeData.bloodGroup">
                </sanabel-selectize>
            </div>

        <div class="col-sm-3">
            <div class="form-group">
                <label class="small">RH</label>
                <sanabel-selectize appcode="290" [tabindex]="34"  [simpleView]="true" [(ngModel)]="patientBloodTypeData.rhValue">
                </sanabel-selectize>
            </div>
        </div>

    </div>


    <div class="container-fluid">
        <div class="row p-3">
            <div class="col">
                <btns-ctrl #btnCtrl1 [appCodes]="[1]" (clicked)="onClicked($event)"></btns-ctrl>
            </div>
        </div>
    </div>
</div>